import i18n from 'i18next';

const titleMap = {
  '^/$': 'BREADCRUMB.HOME',
  '^/sharings$': 'BREADCRUMB.FLEET_SHARINGS',
  '^/sharings/.*$': 'BREADCRUMB.FLEET_SHARINGS',
  '^/vehicles$': 'BREADCRUMB.FLEET',
  '^/vehicles/[a-zA-Z0-9-]+$': 'BREADCRUMB.VEHICLE_DETAILS',

  '^/orders$': 'BREADCRUMB.ORDERS',
  '^/orders/outgoing$': 'BREADCRUMB.ORDERS_OUTGOING',
  '^/orders/outgoing/[^/]+$': 'BREADCRUMB.ORDERS_OUTGOING',
  '^/orders/incoming$': 'BREADCRUMB.ORDERS_INCOMING',
  '^/orders/incoming/[^/]+$': 'BREADCRUMB.ORDERS_INCOMING',
  '^/orders/new$': 'BREADCRUMB.ORDER_NEW',
  '^/orders/edit/[^/]+/[^/]+$': 'BREADCRUMB.ORDER_EDIT',
  '^/orders/details/[^/]+/[^/]+/[^/]+$': 'BREADCRUMB.ORDER_DETAILS',
  '^/orders/reports$': 'BREADCRUMB.REPORTS',
  '^/orders/.*$': 'BREADCRUMB.ORDERS',

  '^/locations$': 'BREADCRUMB.LOCATIONS',
  '^/locations/defined$': 'BREADCRUMB.DEFINED_LOCATIONS',

  '^/email-sharings$': 'BREADCRUMB.SHARINGS',
  '^/requests$': 'BREADCRUMB.REQUESTS',
  '^/requests/.*$': 'BREADCRUMB.REQUESTS',

  '^/carriers$': 'BREADCRUMB.CARRIERS',
  '^/carriers/search$': 'BREADCRUMB.FIND_CARRIER',
  '^/carriers/list$': 'BREADCRUMB.MY_CARRIERS',
  '^/consents$': 'BREADCRUMB.MY_GIVEN_CONSENTS',
  '^/consents/given$': 'BREADCRUMB.MY_GIVEN_CONSENTS',

  '^/telematic-accounts$': 'BREADCRUMB.TELEMATIC_PROVIDER_ACCOUNTS',
  '^/telematic-accounts/create$': 'BREADCRUMB.TELEMATICS_NEW_ACCOUNT',
  '^/telematic-accounts/[^/]+/details$': 'BREADCRUMB.TELEMATICS_MANAGE',
  '^/telematic-accounts/[^/]+/details/view$': 'BREADCRUMB.TELEMATICS_MANAGE',
  '^/telematic-accounts/[^/]+/details/vehicles$': 'BREADCRUMB.TELEMATICS_MANAGE',
  '^/telematic-accounts/.*$': 'BREADCRUMB.TELEMATIC_PROVIDER_ACCOUNTS',
};

const setTitle = ({ path, title }) => {
  if (title) {
    document.title = `${title} | CO3`;
  } else {
    const pathTitle = Object.entries(titleMap).find(([key]) => new RegExp(key).test(path));
    const translationKey = pathTitle && pathTitle[1];
    document.title = `${translationKey ? i18n.t(translationKey) : 'Fleet'} | CO3`;
  }
};

export default {
  setTitle,
};
